import { localDateStr } from "@/pages/entregas/entregasHelpers";

export const STATUS_SAIRAM = ["concluida", "cancelada", "remarcar"];

/** Espelho de acertos_router.calc_totais — usado para recomputar ao (des)marcar entregas na tela. */
export function calcTotais(entregas) {
  const t = { qtd: 0, qtd_concluidas: 0, qtd_canceladas: 0, qtd_remarcadas: 0, troco_saiu: 0, dinheiro_clientes: 0, outras_formas: 0, troco_nao_usado: 0, valor_concluidas: 0, venda_dinheiro: 0 };
  const porForma = new Map();
  for (const e of entregas) {
    const troco = Number(e.troco) || 0, valor = Number(e.valor) || 0;
    t.qtd += 1; t.troco_saiu += troco;
    if (e.status === "concluida") {
      t.qtd_concluidas += 1; t.valor_concluidas += valor;
      if (e.dinheiro) { t.dinheiro_clientes += valor + troco; t.venda_dinheiro += valor; } else t.outras_formas += valor;
      const k = e.forma_pgto_id || "__sem_forma__";
      const pf = porForma.get(k) || { forma_pgto_id: e.forma_pgto_id, nome: e.forma_nome || "Sem forma", dinheiro: !!e.dinheiro, qtd: 0, valor: 0 };
      pf.qtd += 1; pf.valor += valor; porForma.set(k, pf);
    } else if (e.status === "cancelada") { t.qtd_canceladas += 1; t.troco_nao_usado += troco; }
    else if (e.status === "remarcar") { t.qtd_remarcadas += 1; t.troco_nao_usado += troco; }
  }
  t.a_receber = t.dinheiro_clientes + t.troco_nao_usado;
  const r2 = (x) => Math.round(x * 100) / 100;
  for (const k of Object.keys(t)) if (typeof t[k] === "number" && !k.startsWith("qtd")) t[k] = r2(t[k]);
  t.por_forma = [...porForma.values()].map((pf) => ({ ...pf, valor: r2(pf.valor) })).sort((a, b) => b.valor - a.valor);
  return t;
}

export const fmtD = (s) => (s ? String(s).slice(0, 10).split("-").reverse().join("/") : "—");
export const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");

export function periodoPreset(kind) {
  const hoje = new Date();
  const d = (n) => localDateStr(new Date(hoje.getTime() + n * 86400000));
  if (kind === "hoje") return { start: d(0), end: d(0) };
  if (kind === "ontem") return { start: d(-1), end: d(-1) };
  if (kind === "7d") return { start: d(-6), end: d(0) };
  if (kind === "mes") return { start: `${localDateStr().slice(0, 7)}-01`, end: d(0) };
  return { start: "", end: "" };
}
